import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSection$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSection extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5ebc25b289ae8baaba8110e0eb36e33c9f64feed', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '81ced9736096223bc5e0393c44259c99ae452988', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ad520fa38dabd0f06ff52071aa49d07ce1fabbc0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.124 12.014v.035-.042zm-2.198-2.93c1.316.884 2.183 1.584 2.198 2.93a2.65 2.65 0 0 1-1.576 2.357c.13.286.194.598.186.912 0 1.597-1.327 2.717-3.4 2.717H7.099a.62.62 0 0 1-.643-.622v-.768a.62.62 0 0 1 .643-.601h3.214c.622 0 1.078-.373 1.078-.705s-.186-.58-1.12-1.14L8.199 12.94C6.85 12.07 6 11.364 6 9.996a2.59 2.59 0 0 1 1.576-2.364c-.14-.29-.212-.61-.207-.933 0-1.576 1.347-2.696 3.42-2.696h3.236a.62.62 0 0 1 .684.622v.747a.622.622 0 0 1-.684.705H10.81c-.622 0-1.058.31-1.058.642s.187.602 1.1 1.162zm-.624 3.815c.28-.194.45-.51.456-.85 0-.374-.124-.643-1.12-1.224l-2.28-1.369-.56-.373a1.16 1.16 0 0 0-.457.871c0 .373.125.622 1.12 1.223l2.281 1.348z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-section", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-section"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-section":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSection$1);
            }
            break;
    } });
}

const CosmosIconSection = CosmosIconSection$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSection, defineCustomElement };
